// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const centiskorch: PokeData = {
  "id": 851,
  "name": "centiskorch",
  "height": 30,
  "weight": 1200,
  "base_experience": 184,
  "types": [
    PokeType.FIRE,
    PokeType.BUG
  ],
  "api_moves": [
    "slam",
    "wrap",
    "bite",
    "ember",
    "fire-spin",
    "smokescreen",
    "flame-wheel",
    "crunch",
    "bug-bite",
    "coil",
    "inferno",
    "lunge",
    "fire-lash",
    "burn-up"
  ],
  "moves": [
    "bite",
    "ember",
    "fire-spin",
    "crunch",
    "bug-bite",
    "lunge",
    "flare-blitz",
    "sunny-day",
    "heal-order",
    "pin-missile",
    "pounce",
    "flamethrower",
    "string-shot"
  ],
  "evolution_chain": {
    "id": 447,
    "item": null,
    "species": [
      {
        "name": "sizzlipede",
        "order": 850,
        "types": [
          PokeType.FIRE,
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "centiskorch",
        "order": 851,
        "types": [
          PokeType.FIRE,
          PokeType.BUG
        ],
        "evolves_from_species_id": 850,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 132,
    "speed": 97,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
